export async function readBlobBusinessError(blob) {
  if (!blob || typeof blob.text !== 'function') return ''
  const type = String(blob.type || '').toLowerCase()
  if (type.indexOf('application/json') === -1 && type.indexOf('text/json') === -1) return ''
  try {
    const text = await blob.text()
    if (!text) return ''
    const result = JSON.parse(text)
    if (result && typeof result.code !== 'undefined' && result.code !== 0) {
      return result.message || '操作失败'
    }
  } catch (error) {
    return ''
  }
  return ''
}

export function downloadBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = blob.fileName || fileName || 'download'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export function openBlob(blob) {
  const url = window.URL.createObjectURL(blob)
  const opened = window.open(url, '_blank')
  window.setTimeout(() => {
    window.URL.revokeObjectURL(url)
  }, 60000)
  return !!opened
}

export function replaceObjectUrl(currentUrl, blob) {
  revokeObjectUrl(currentUrl)
  return window.URL.createObjectURL(blob)
}

export function revokeObjectUrl(url) {
  if (!url) return
  window.URL.revokeObjectURL(url)
}
